module.exports = __webpack_public_path__ + "static/assets/bd7423727ceafe223040a8557306e077.svg";